import { SharedModule } from 'src/app/shared/shared.module'

import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { StoreModule } from '@ngrx/store'
import * as fromEmployeeBooking from './employee-booking.reducer'
import { EffectsModule } from '@ngrx/effects'
import { EmployeeBookingEffects } from './employee-booking.effects'
import { EmployeeBookingService } from './employee-booking.service'
import { EmployeeBookingSerializer } from './employee-booking.serializer'
import { TagModule } from '../../tag/tag.module'
import { EmployeeBookingCreateModalComponent } from './create-modal/show.component'
import { EmployeeBookingFormComponent } from './form/form.component'
import { EmployeeBookingInvoiceComponent } from './invoice/index.component'
import { InvoiceTableComponent } from './invoice/invoice-table/show.component'

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        TagModule,
        StoreModule.forFeature(fromEmployeeBooking.FEATURE_NAME, fromEmployeeBooking.employeeBookingReducer),
        EffectsModule.forFeature([EmployeeBookingEffects])
    ],
    declarations: [
        EmployeeBookingCreateModalComponent,
        EmployeeBookingFormComponent,
        EmployeeBookingInvoiceComponent,
        InvoiceTableComponent
    ],
    exports: [
        EmployeeBookingCreateModalComponent,
        EmployeeBookingFormComponent,
        InvoiceTableComponent
    ],
    providers: [
        EmployeeBookingService,
        {
            provide: EmployeeBookingSerializer,
            useClass: EmployeeBookingSerializer
        }
    ]
})
export class EmployeeBookingModule {}
